import React, { useEffect } from "react";
import Mainlayout from "layouts/main";
import AuthProvider from "contexts/auth";
import AppProvider from "contexts/app"
import WorkspaceProvider from "contexts/workspace"
import { Button, ConfigProvider, Space, App } from 'antd';
import useIsMobile from '@/hooks/useIsMobile';

//algorithm: theme.darkAlgorithm,
const ThuyTienApp = () => {
    const isMobile = useIsMobile(430);
    var card = null;
    var modal = null;
    if (isMobile) {
        card = {
            styles: { body: { padding: 12 } }
        }
        modal = {width: '100vw'}
    }




    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: '#1677ff',
                },
            }}
            card={card}
            modal={modal}

        >
            <App>


                <AppProvider>


                    <AuthProvider>

                        <WorkspaceProvider>
                            <Mainlayout></Mainlayout>
                        </WorkspaceProvider>


                    </AuthProvider>
                </AppProvider>
            </App>
        </ConfigProvider>
    );
};

export default ThuyTienApp;
